/* src/app/shared/components/transaction-list/transaction-list.component.scss */
.transaction-container {
  padding-bottom: 80px;
}
/*# sourceMappingURL=transaction-list.component.css.map */
